module.exports = __webpack_public_path__ + "static/detectivepikachu-db657fb570687779ff46ec5cb618a6d8.jpg";